import React, { useState, useCallback, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useHistory } from 'react-router-dom';
import SelectTab from '../share/SelectTab';
import Total from './total/total';
import Items from './items/items';
import Cancel from './cancel/cancel';

const RakutenHotelFlow = {
  NEW: '新規',
  CANCEL: 'キャンセル'
} as const;
export type RakutenHotelFlowType = keyof typeof RakutenHotelFlow;

const RakutenHotelTab = {
  TOTAL: '総数',
  ITEMS: '全件'
} as const;
export type RakutenHotelTabType = keyof typeof RakutenHotelTab;

const RakutenHotelCancelTab = {
  ITEMS: '全件'
} as const;
export type RakutenHotelCancelTabType = keyof typeof RakutenHotelCancelTab;

const RakutenHotel = observer(() => {
  const history = useHistory();
  const [rakutenHotelFlow, setRakutenHotelFlow] = useState<RakutenHotelFlowType>(
    (utils.getParam('rakuten_hotel_flow') as RakutenHotelFlowType) || 'NEW'
  );
  const [rakutenHotelTab, setRakutenHotelTab] = useState<RakutenHotelTabType>(
    (utils.getParam('rakuten_hotel_type') as RakutenHotelTabType) ||
      (utils.getParam('rakuten_hotel_tab') as RakutenHotelTabType) ||
      'TOTAL'
  );
  const [rakutenHotelCancelTab, setRakutenHotelCancelTab] = useState<RakutenHotelCancelTabType>('ITEMS');

  useEffect(() => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
    currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
    if (!currentParams.has('rakuten_hotel_flow')) {
      currentParams.set('rakuten_hotel_flow', rakutenHotelFlow);
    }
    if (!currentParams.has('rakuten_hotel_type')) {
      currentParams.set(
        'rakuten_hotel_type',
        rakutenHotelFlow === 'CANCEL' ? rakutenHotelCancelTab : rakutenHotelTab
      );
    }
    history.replace(`/arrangement/todo_list?${currentParams.toString()}`);
  }, [history, rakutenHotelFlow, rakutenHotelTab, rakutenHotelCancelTab]);

  const handleFlowChange = useCallback(
    (flow: RakutenHotelFlowType) => {
      setRakutenHotelFlow(flow);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
      currentParams.set('rakuten_hotel_flow', flow);
      const innerTab = flow === 'CANCEL' ? rakutenHotelCancelTab : rakutenHotelTab;
      currentParams.set('rakuten_hotel_type', innerTab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history, rakutenHotelTab, rakutenHotelCancelTab]
  );

  const handleNewTabChange = useCallback(
    (tab: RakutenHotelTabType) => {
      setRakutenHotelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
      currentParams.set('rakuten_hotel_flow', 'NEW');
      currentParams.set('rakuten_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  const handleCancelTabChange = useCallback(
    (tab: RakutenHotelCancelTabType) => {
      setRakutenHotelCancelTab(tab);
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set('tab', 'AUTO_RESERVATION_INVENTORY');
      currentParams.set('sub_tab', 'RAKUTEN_HOTEL');
      currentParams.set('rakuten_hotel_flow', 'CANCEL');
      currentParams.set('rakuten_hotel_type', tab);
      history.push(`/arrangement/todo_list?${currentParams.toString()}`);
    },
    [history]
  );

  return (
    <>
      <SelectTab tabs={RakutenHotelFlow} currentTab={rakutenHotelFlow} onChange={handleFlowChange} />
      {rakutenHotelFlow === 'NEW' ? (
        <>
          <SelectTab tabs={RakutenHotelTab} currentTab={rakutenHotelTab} onChange={handleNewTabChange} />
          {rakutenHotelTab === 'ITEMS' ? <Items /> : <Total />}
        </>
      ) : (
        <>
          <SelectTab
            tabs={RakutenHotelCancelTab}
            currentTab={rakutenHotelCancelTab}
            onChange={handleCancelTabChange}
          />
          <Cancel />
        </>
      )}
    </>
  );
});

export default RakutenHotel;
